// localStorage helpers for the LibraryDropConfirmPopover Amazon-link opt-in.
// Split out from the component file so HMR / react-refresh stays clean.
const STORAGE_KEY = "excerptus.libraryDrop.amazonLinkDefault";

export const readAmazonLinkDefault = (): boolean => {
  if (typeof window === "undefined") return true;
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (raw === null) return true;
  return raw === "1";
};

export const writeAmazonLinkDefault = (value: boolean): void => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(STORAGE_KEY, value ? "1" : "0");
};
